import {
	ApplicantInterviewProvider,
	useApplicantInterviewWizard,
} from './useApplicantInterviewWizard';
import { LandingPage } from './LandingPage';
import { WizardProvider } from '../../../components/wizard/useWizard';
import { Grid } from 'antd';

const { useBreakpoint } = Grid;

export const ApplicantContextPolicy = () => {
	const { application } = useApplicantInterviewWizard();
	const { applicant } = application;
	const screens = useBreakpoint();
	const isMobile = !screens.sm;
	return (
		<div className="flex justify-center">
			<div
				className={`flex flex-col h-full min-h-0 p-[8px] ${
					isMobile ? 'w-full' : 'w-[90%]'
				}`}
			>
				<LandingPage applicantInfo={applicant} />,
			</div>
		</div>
	);
};

export const ApplicantContextWizardContainer = () => {
	return (
		<ApplicantInterviewProvider>
			<WizardProvider>
				<ApplicantContextPolicy />
			</WizardProvider>
		</ApplicantInterviewProvider>
	);
};
